<div class="feature">
  <h5 class="font-16 fw-bold text-start text-uppercase text-white mb-0">{{ 'feature.title' | translate }}</h5>
  <div class="marquee">
    <div class="track">
      <div class="content">
        <img loading="lazy" src="{{ item.img }}" *ngFor="let item of items" alt="featured-img" />
      </div>
    </div>
    <div class="track">
      <div class="content">
        <img loading="lazy" src="{{ item.img }}" *ngFor="let item of items" alt="featured-img" />
      </div>
    </div>
  </div>
</div>
